export default __webpack_public_path__ + "static/media/01_DAIF_Data_02_01.b3130d91.mp4";